import { render, staticRenderFns } from "./metadata-box.vue?vue&type=template&id=2d4737ae&"
import script from "./metadata-box.vue?vue&type=script&lang=js&"
export * from "./metadata-box.vue?vue&type=script&lang=js&"
import style0 from "./metadata-box.vue?vue&type=style&index=0&id=2d4737ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports